import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {encode: false});
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/labourerPayments`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/labourerPaymentItems/${id}`, options)
        .then(response => {
            let labourerPaymentItems = jsona.deserialize(response.data);
            delete labourerPaymentItems.links;
            return labourerPaymentItems;
        });
}


function show(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/labourerPaymentItems/${id}`, options)
        .then(response => {
            let labourerPaymentItems = jsona.deserialize(response.data);
            delete labourerPaymentItems.links;
            return labourerPaymentItems;
        });
}

function add(labourerPaymentItems) {
    const payload = jsona.serialize({
        stuff: labourerPaymentItems,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/labourerPaymentItems`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(labourerPaymentItems) {
    const payload = jsona.serialize({
        stuff: labourerPaymentItems,
        includeNames: ['vendor']
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/labourerPaymentItems/${labourerPaymentItems.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/labourerPaymentItems/${id}`, options);
}

function getReadyLabourers(params) {
    return axios.get(`${url}/payments/ready-labourers`, {params})
        .then(response => {
            return {
                list: response.data.data,
                meta: response.data.meta,
            }
        });
}

function getLabourerSchedules(params) {
    const {labourerId, ...queryParams} = params;
    return axios.get(`${url}/payments/labourers/${labourerId}/schedules`, {params: queryParams})
        .then(response => response.data);
}

function createPayment(payload) {
    return axios.post(`${url}/payments`, payload)
        .then(response => response.data);
}

function listPayments(params) {
    return axios.get(`${url}/payments`, {params})
        .then(response => response.data);
}

function viewPayment(id, params) {
    params = params || {};
    return axios.get(`${url}/labourerPayments/${id}`, {
        params: params,
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    })
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function approvePayment(id) {
    return axios.post(`${url}/payments/${id}/approve`)
        .then(response => response.data);
}

function markAsPaid(id) {
    return axios.post(`${url}/payments/${id}/mark-paid`)
        .then(response => response.data);
}

function cancelPayment(id, payload) {
    return axios.post(`${url}/payments/${id}/cancel`, payload)
        .then(response => response.data);
}

export default {
    list,
    get,
    show,
    add,
    update,
    destroy,
    getReadyLabourers,
    getLabourerSchedules,
    createPayment,
    listPayments,
    viewPayment,
    approvePayment,
    markAsPaid,
    cancelPayment
};